import React from "react";
import withStyles from "react-jss";
import classNames from "classnames";

const styles = theme => {
    return {
        root: {
            width: "60px",
            height: "60px",
            borderRadius: "50%",
            boxShadow: "0 2px 4px 0 rgba(43, 29, 92, 0.3)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            cursor: "pointer",
            transform: "translate3d(0,0,0)",
            right: 0,
            top: 0,
            '& span[class^="icon"]': {
                fontSize: "24px",
            },
        },
        isOpen: {
            position: "absolute",
            right: "30px",
            top: "-30px",
            zIndex: 6,
        },
        isHide: {
            display: "none",
        },
        whiteTheme: {
            backgroundColor: theme.palette.colors.white,
            '& span[class^="icon"]': {
                color: theme.palette.colors.purplishBlue,
            },
        },
        yellowTheme: {
            backgroundColor: theme.palette.colors.yellow,
            '& span[class^="icon"]': {
                color: theme.palette.colors.purplishBlue,
            },
        },
        blueTheme: {
            backgroundColor: theme.palette.colors.purplishBlue,
            '& span[class^="icon"]': {
                color: theme.palette.colors.yellow,
            },
        },
        pinkTheme: {
            backgroundColor: theme.palette.colors.giftPink,
            '& span[class^="icon"]': {
                color: theme.palette.colors.white,
            },
        },
        blinking: {
            animation: "shaking infinite linear 10s",
            "&:after": {
                position: "absolute",
                content: "''",
                top: 0,
                bottom: 0,
                right: 0,
                left: 0,
                borderRadius: "50%",
                border: `1px solid ${theme.palette.colors.yellow}`,
                transform: "scale(1)",
                animation: "blinking infinite linear 1s",
            },
        },
        typeB_Blinking: {
            "& span": {
                animation: "blinking_2 2s infinite ease-in-out",
            },
        },
        circle: {
            width: "100%",
            height: "100%",
            border: "1px solid",
            borderRadius: "50%",
            position: "absolute",
            top: 0,
            left: 0,
            transformOrigin: "50% 50%",
            backgroundColor: theme.palette.colors.yellowGreen,
        },
        circle1: {
            animation: "pin 2.5s linear .4s infinite normal",
        },
        circle2: {
            animation: "pin 2s linear 0s infinite normal",
        },
        [`@media (max-width: ${theme.media.sm})`]: {
            root: {
                width: "50px",
                height: "50px",
                '& span[class^="icon"]': {
                    fontSize: "20px",
                },
            },
            isOpen: {
                right: "20px",
                top: "-25px",
            },
        },
    };
};

class CircleButton extends React.Component {
    render() {
        let classes = this.props.classes;
        return (
            <div
                className={classNames(classes.root, {
                    [classes.isOpen]: this.props.isOpen,
                    [classes.isHide]: this.props.isHide,
                    [classes.whiteTheme]: this.props.whiteTheme,
                    [classes.yellowTheme]: this.props.yellowTheme,
                    [classes.blueTheme]: this.props.blueTheme,
                    [classes.pinkTheme]: this.props.pinkTheme,
                    [classes.blinking]: this.props.blinking,
                    [classes.typeB_Blinking]: this.props.typeB,
                })}
                onClick={this.props.onClick}
                datatest={this.props.datatest}
            >
                {this.props.typeB && (
                    <div
                        className={classNames(classes.circle, classes.circle1)}
                    />
                )}
                {this.props.typeB && (
                    <div
                        className={classNames(classes.circle, classes.circle2)}
                    />
                )}
                {this.props.children}
            </div>
        );
    }
}
export default withStyles(styles)(CircleButton);
